import { createContext } from 'react'

export interface HelpWidgetController {
  /** Open the help widget for general chat — used by surfaces like the project overview's
   *  "Open chat" button so the user can ask questions or request changes about the project. Opens
   *  the docked side panel; a no-op when the panel is already open. */
  openGeneralHelp: () => void
}

// Defaults to a no-op so components used outside the AppShell (tests, storybook) don't crash.
export const HelpWidgetContext = createContext<HelpWidgetController>({
  openGeneralHelp: () => {},
})
